import { PageController } from '@client/components/_core/layout/PageController';
import { History as HistoryOriginal } from '@client/components/_ui/display/History';
import { createFileRoute } from '@tanstack/react-router';
import { claimFormStore } from '../store';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/history')({
    component: History,
});

function History() {
    const claim = claimFormStore.use.formData();

    return (
        <PageController route={Route}>
            <HistoryOriginal idPropertyName="claimId" idValue={claim.id} />
        </PageController>
    );
}
